var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoReporDin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.7 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #c12b7d;\n        opacity:0.95;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.6,25.9h-5.5c-.7,0-1.2.5-1.2,1.2s.5,1.2,1.2,1.2h5.5c.7,0,1.2-.5,1.2-1.2s-.5-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.7,19.6h-10.6c-.7,0-1.2.5-1.2,1.2s.5,1.2,1.2,1.2h10.6c.7,0,1.2-.5,1.2-1.2s-.5-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.7,13.3h-10.6c-.7,0-1.2.5-1.2,1.2s.5,1.2,1.2,1.2h10.6c.7,0,1.2-.5,1.2-1.2s-.5-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.3,8.2L19.5.5s0,0,0,0c0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0,0,0,0,0,0,0-.1,0-.2,0,0,0,0,0,0,0H2.3C1.6,0,1.1.6,1.1,1.3v32.3c0,.7.5,1.2,1.2,1.2h24.1c.7,0,1.2-.5,1.2-1.2V9.1c0-.3-.1-.6-.4-.9ZM19.8,4.2l3.7,3.7h-3.7v-3.7ZM3.5,32.4V2.5h13.9v6.6c0,.7.5,1.2,1.2,1.2h6.6v22.1H3.5Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3,
    y: 0,
    width: 34.8,
    height: 35
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoReporDin);
export default __webpack_public_path__ + "static/media/Icono_repor_din.e5aecefe6a79d3bdda95b2d6f9235380.svg";
export { ForwardRef as ReactComponent };